// extracted by mini-css-extract-plugin
export var button = "Accordion-module--button--PbYM6";
export var component = "Accordion-module--component--STSH6";
export var content = "Accordion-module--content--f6LH1";
export var hidden = "Accordion-module--hidden--b1gBw";
export var icon = "Accordion-module--icon--Y45G0";
export var list = "Accordion-module--list--xgWIG";
export var row = "Accordion-module--row--I0Mye";
export var title = "Accordion-module--title--8mSCr";